import './styles.scss'

import { useMemo } from 'react'
import { useLocation } from 'react-router'

import B2BecLink from '@/components/B2BLink'

import { SUB_ITEM_LIST_TYPES } from '../../product-navigation.constants'

const emptyListData = []

function SubItemList(props) {
  const {
    type = SUB_ITEM_LIST_TYPES.CATEGORY_OVERVIEW,
    mainCategoryId = undefined,
    subCategoryId = undefined,
    listData = emptyListData,
  } = props

  const location = useLocation()
  const productTypeLinkPrefix = useMemo(() => {
    const result = /^\/accessories|\/detergents/.exec(location.pathname)
    return result && result.length > 0 ? result[0] : ''
  }, [location.pathname])

  if (listData.length === 0) {
    return null
  }
  if (type === SUB_ITEM_LIST_TYPES.SUB_CATEGORY_OVERVIEW) {
    return (
      <ul className="sub-item__list m-0">
        {listData.map((item) => (
          <li key={item.categoryId} className="mb-1">
            <h3 className="m-0">
              <B2BecLink
                to={`${productTypeLinkPrefix}/category/${mainCategoryId}/subcategory/${subCategoryId}/class/${item.categoryId}`}
              >
                {item.categoryName}
              </B2BecLink>
            </h3>
          </li>
        ))}
      </ul>
    )
  }
  return (
    <ul className="sub-item__list m-0">
      {listData.map((item) => (
        <li key={item.categoryId} className="mb-1">
          <h3 className="m-0">
            <B2BecLink
              to={`${productTypeLinkPrefix}/category/${mainCategoryId}/subcategory/${item.categoryId}`}
            >
              {item.categoryName}
            </B2BecLink>
          </h3>
        </li>
      ))}
    </ul>
  )
}

export default SubItemList
